import React from 'react';
import PropTypes from 'prop-types';
import { BsBag } from 'react-icons/bs';
import './UserCard.css';
import verified from '../../assets/badge-influencer.svg';

const UserCard = ({ image, name, badge, occupation, button }) => {
  return (
    <div className="flex flex-ai-c flex-jc-sb card">
      <div className="flex">
        <div className="image">
          <img src={image} alt="" />
        </div>
        <div>
          <div className="user">
            <h5>{name}</h5>
            {badge && <img src={verified} alt="badge" />}
          </div>
          <div className="flex">
            <BsBag className="icon icon--xxs" />
            <p>{occupation}</p>
          </div>
        </div>
      </div>
      <div>
        <button type="button" className="btn btn--outline">
          {button}
        </button>
      </div>
    </div>
  );
};

UserCard.propTypes = {
  image: PropTypes.string,
  name: PropTypes.string,
  badge: PropTypes.bool,
  occupation: PropTypes.string,
  button: PropTypes.string,
};

UserCard.defaultProps = {
  image:
    'https://i0.wp.com/www.repol.copl.ulaval.ca/wp-content/uploads/2019/01/default-user-icon.jpg',
  name: 'Laolu Onifade',
  badge: false,
  occupation: 'Music Artiste',
  button: 'Follow',
};

export default UserCard;
